export const parseWalletIdFromSearch = (search) => {
  const params = new URLSearchParams(search);
  return params.get("walletId");
};

export const truncateWalletAddress = (address) => {
  if (!address || address.length < 12) return address ?? "";
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
};
